import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  IconButton,
  Input,
} from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";
import { editField, addField, deleteArrayItem } from "../store/fileReducer";

import RemoteCommands from "./RemoteCommands";
import RemoteTargeting from "./RemoteTargeting";

export const DEFAULT_TARGETING = {
  models: [],
  swid: [],
  times: [],
  state: [],
  environment: [],
  timezone: [],
  internet: [],
  rxid: [],
  dma: [],
  zip: [],
  bandwidth: "",
};

const useStyles = makeStyles((theme) => ({
  btnWrapper: {
    marginTop: "1rem",
  },
}));

const Remote = () => {
  const classes = useStyles();
  const { root: rows } = useSelector(({ file }) => file);
  const dispatch = useDispatch();
  const addRemote = () =>
    dispatch(
      addField(`root`, {
        title: "New Feature",
        features: [],
        targeting: DEFAULT_TARGETING,
      })
    );

  const remove = (i) => {
    const toDelete = window.confirm(
      "Are you sure you want to delete this feature group?"
    );
    toDelete && dispatch(deleteArrayItem(`root`, i));
  };

  return (
    <>
      <div className={classes.btnWrapper}>
        <Button
          onClick={addRemote}
          variant="contained"
          size="small"
          color="primary"
        >
          New Feature Group
        </Button>
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={"50%"}>Name</TableCell>
            <TableCell>Features</TableCell>
            <TableCell>Targeting</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => {
            return (
              <TableRow key={i}>
                <TableCell>
                  <Input
                    fullWidth
                    value={row.title}
                    onChange={(e) =>
                      dispatch(
                        editField(`root[${i}].title`, e.currentTarget.value)
                      )
                    }
                  />
                </TableCell>
                <TableCell>
                  <RemoteCommands i={i} />
                </TableCell>
                <TableCell>
                  <RemoteTargeting i={i} />
                </TableCell>
                <TableCell>
                  <IconButton
                    size="small"
                    onClick={() => {
                      dispatch(
                        addField(`root`, {
                          ...row,
                          title: `Copy of ${row.title}`,
                        })
                      );
                    }}
                  >
                    <FileCopyIcon fontSize="inherit" />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <IconButton size="small" onClick={() => remove(i)}>
                    <DeleteIcon fontSize="inherit" />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};

export default Remote;
